import { Dispatch, Action } from "redux";
import { AxiosError, AxiosResponse } from "axios";
import { notification } from "antd";

import {
  NavigationPath,
  findResponseByInsuranceId,
  history,
  addInsuranceOfferResponseFormData,
  downloadBlobFile,
  showErrorNotification,
} from "../../../../utils";
import { ApiService, ApiServiceFormData } from "../../../../services";
import {
  GET_REQUEST_DETAILS_BY_ID,
  GET_RESPONSE_DETAILS_BY_ID,
  IS_LOADING,
  IS_SENT,
} from "./types";
import { ResponseFormType } from "../../../../models";

const setLoading = (loading: boolean) => ({
  type: IS_LOADING,
  payload: loading,
});

const setSent = (sent: boolean) => ({
  type: IS_SENT,
  payload: sent,
});

export const getInsuranceOfferRequestsDetails =
  (id: string, insuranceId: string) => async (dispatch: Dispatch<Action>) => {
    dispatch(setSent(false));
    ApiService.get(`/offer-request/${id}`)
      .then(async (res: AxiosResponse) => {
        const { status, data } = res;
        if (status !== 200) {
          showErrorNotification("Učitavanje zahtjeva za ponudu nije uspjelo");
          return;
        }
        dispatch({
          type: GET_REQUEST_DETAILS_BY_ID,
          payload: data,
        });

        const responseId = findResponseByInsuranceId(
          data.offerResponse,
          insuranceId
        );

        if (responseId) {
          await getInsuranceOfferResponseDetails(responseId)(dispatch);
        }
      })
      .catch((err: AxiosError) => {
        showErrorNotification(
          "Učitavanje zahtjeva za ponudu nije uspjelo",
          err
        );
      });
  };

export const getInsuranceOfferResponseDetails =
  (id: string) => async (dispatch: Dispatch<Action>) => {
    ApiService.get(`/offer-response/${id}`)
      .then((res: AxiosResponse) => {
        const { status, data } = res;
        if (status !== 200) {
          showErrorNotification("Učitavanje ponude nije uspjelo");
          return;
        }

        dispatch({
          type: GET_RESPONSE_DETAILS_BY_ID,
          payload: data,
        });
        dispatch(setSent(true));
      })
      .catch((err: AxiosError) => {
        showErrorNotification("Učitavanje ponude nije uspjelo", err);
      });
  };

export const addInsuranceOfferResponse =
  (offerRequestId: string, offerResponse: ResponseFormType) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(setLoading(true));

    const formData = addInsuranceOfferResponseFormData(
      offerRequestId,
      offerResponse
    );

    ApiServiceFormData.post("/offer-response", formData)
      .then((res: AxiosResponse) => {
        const { status } = res;

        if (status !== 201) {
          showErrorNotification("Slanje ponude nije uspjelo");
          return;
        }
        notification.success({
          message: "Ponuda je poslana.",
        });
        history.navigate(NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE);
      })
      .catch((err: AxiosError) => {
        showErrorNotification("Slanje ponude nije uspjelo", err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

export const downloadFile =
  (id: string, filename: string) => async (dispatch: Dispatch<Action>) => {
    ApiService.get(`offer-response/${id}/file-download`, {
      responseType: "blob",
    })
      .then((res) => {
        downloadBlobFile(new Blob([res.data]), filename);
      })
      .catch((err: AxiosError) => {
        showErrorNotification("Preuzimanje fajla nije uspjelo", err);
      });
  };
